import { getApiBase } from "../helpers/helpers";

export type TypeaheadVehicle = {
    id: number;
    year: number;
    make: string;
    model: string;
    trim: string;
    cab: string;
    full_name: string;
};

// Mirrors the server's own minimum (queries shorter than this always
// return { vehicles: [] }) — checked client-side too, to avoid firing
// a request for every keystroke below the threshold.
export const TYPEAHEAD_MIN_QUERY_LENGTH = 2;

export async function fetchVehicleTypeahead(q: string): Promise<TypeaheadVehicle[]> {
    if (q.trim().length < TYPEAHEAD_MIN_QUERY_LENGTH) return [];

    const url = `${getApiBase()}/api/v1/vehicles/typeahead?q=${encodeURIComponent(q)}`;
    const response = await fetch(url, { mode: "cors" });
    if (!response.ok) throw new Error(`Vehicle typeahead fetch failed: ${response.statusText}`);
    const data = await response.json();
    return Array.isArray(data?.vehicles) ? data.vehicles : [];
}
